const config = {
  contactEmail: 'contact@breakroomcup.com',
  socialMedias: {
    instagram: 'https://www.instagram.com/breakroomcup/',
  },
  // In development (npm start), fetch from local nest-brc on 3002; otherwise production URL
  baseURL: process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:3002' : 'https://shark-app-d9vui.ondigitalocean.app'),
  environment: process.env.REACT_APP_ENV || 'production',
  // Public Web client ID (not a secret). Must match nest-brc GOOGLE_CLIENT_ID.
  googleClientId: (process.env.REACT_APP_GOOGLE_CLIENT_ID || '106076315320-66ki83ackgl2tomaop01aevks1m8o8rl.apps.googleusercontent.com').trim(),
  stripe: {
    publishableKey: (process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '').trim(),
  },
  email: {
    serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
    templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '',
    publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '',
  },
}

export default config
